import React from "react";
import Button from "@mui/material/Button";
import { Tooltip } from "@mui/material";
import { connect } from "react-redux";
import { setSelectedServer } from "../../store/actions/roomActions";
import { chatTypes, setChosenChatDetails } from "../../store/actions/chatActions";

const ServerButton = ({ server, selectedServer, setSelectedServer, setChosenChatDetails }) => {
  const isActive = selectedServer?.id === server.id;
  const serverName = server.name || "";
  const iconUrl = server.iconUrl || "";

  const handleSelect = () => {
    setSelectedServer(server);
    const textChannel = server.channels.find((channel) => channel.type === "TEXT");
    if (textChannel) {
      setChosenChatDetails(
        {
          id: textChannel.id,
          name: `# ${textChannel.name}`,
          serverId: server.id,
          channelType: "TEXT",
        },
        chatTypes.CHANNEL
      );
    }
  };

  return (
    <Tooltip title={server.name} placement="right">
      <Button
        onClick={handleSelect}
        style={{
          width: "48px",
          height: "48px",
          borderRadius: isActive ? "16px" : "50%",
          margin: 0,
          padding: 0,
          minWidth: "0",
          marginTop: "10px",
          color: "white",
          backgroundColor: isActive ? "#f97316" : "#24262b",
          backgroundImage: iconUrl ? `url("${iconUrl}")` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          fontWeight: 800,
          overflow: "hidden",
        }}
      >
        {!iconUrl && serverName.substring(0, 2).toUpperCase()}
      </Button>
    </Tooltip>
  );
};

const mapStoreStateToProps = ({ room }) => ({
  selectedServer: room.selectedServer,
});

export default connect(mapStoreStateToProps, {
  setSelectedServer,
  setChosenChatDetails,
})(ServerButton);
